import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'


import PreviousDeployments from "../views/PreviousDeployments.vue"
import Dashboard from "../views/Dashboard.vue"
import PublicGraphing from "../views/PublicGraphDeployments.vue"


Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Dashboard
  },

  {
    path: "/dashboard/graphs/deployment/:id",
    component: PublicGraphing
  },

  {
    path: '/dashboard',
    component: Dashboard,
    name: 'dashboard',
  },

  { 
    path: '/dashboard/previousdeployments', 
    component: PreviousDeployments, 
    name: 'previous' 
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
